<template>
    <div>
        <ListingList 
            @edit="handleEdit" 
            title="RFPs"
            description="Manage all RFPs on the platform"
            type="rfp"
            :editable="false"
            @view="handleView"
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import ListingList from '../listings/ListingList.vue';

const router = useRouter();

const handleEdit = (id) => {
    localStorage.setItem('temp_editing_listing_id', Number(id));
    router.push({
        name: 'rfp-edit',
        params: {
            id: id
        }
    });
}

const handleView = (id) => {
    router.push({
        name: 'item-detail',
        params: {
            id: id
        }
    });
}
</script>